export default "__VITE_ASSET__88d445ea__"